'use client'
import {Container} from "react-bootstrap";
import styles from "./footer.module.scss";
import Image from "next/image";
import Stores from "../../libs/stores/Stores";
import Socials from "../../libs/socials/Socials";
import FooterMenu from "./menu/FooterMenu";

export default function Footer() {
    const year = new Date().getFullYear();

    return (
        <section className={styles.footer}>
            <Container fluid={"lg"} className={"flex justify-content-between flex-xs-column"}>
                <div>
                    <Image
                        src="/images/logo-large.svg"
                        alt="Logo large"
                        width={114}
                        height={32}
                    />
                    <p className={"mt-2"}>
                        Bringing the playground to your phone. Connecting athletes of all levels one-pickup game at a
                        time.
                        <br/>
                        Aspiring to make playing sports accessible for all.
                    </p>
                    <FooterMenu/>

                    <p>&copy;{year} PUP App</p>
                </div>
                <div>
                    <div className="mt-4">
                        <Stores/>
                    </div>
                    <Socials/>
                </div>
            </Container>
        </section>
    );
}
